import { EmptyGroupBlockCombinedProps } from './types';

const usePresenter = (props: EmptyGroupBlockCombinedProps): EmptyGroupBlockCombinedProps => {
  return props;
};

export default usePresenter;
